/**
 * date-fns format strings. Use these instead of inline literals so the format
 * stays consistent across the app and is changed in one place.
 */
export const DateFormat = {
	/** Day-month-year for display, e.g. `01.06.2026`. */
	Display: "dd.MM.yyyy",
	/** Day-month-year without leading zeros, e.g. `1.6.2026`. */
	DisplayShort: "d.M.yyyy",
	/** Day-month-year with time for display, e.g. `01.06.2026 14:30`. */
	DisplayWithTime: "dd.MM.yyyy HH:mm",
	/** Day-month-year without leading zeros, with time, e.g. `1.6.2026 14:30`. */
	DisplayShortWithTime: "d.M.yyyy HH:mm",
	/** Month and year, e.g. `06/2026`. */
	MonthYear: "MM/yyyy",
	/** Full month name and year, e.g. `June 2026`. */
	MonthYearLong: "LLLL yyyy",
	/** ISO date for API payloads, e.g. `2026-06-01`. */
	Iso: "yyyy-MM-dd",
} as const;
